import { useEffect, useState } from "react";
import {
  getSearchHistory,
  removeSearchHistory,
  saveSearchHistory,
} from "../../../lib/searchHistory";

type UseRecentSearchesResult = {
  recentSearches: string[];
  saveSearch: (term: string) => void;
  removeSearch: (term: string) => void;
};

const useRecentSearches = (open: boolean): UseRecentSearchesResult => {
  const [recentSearches, setRecentSearches] = useState<string[]>(() =>
    getSearchHistory(),
  );

  useEffect(() => {
    if (open) setRecentSearches(getSearchHistory());
  }, [open]);

  function saveSearch(term: string) {
    saveSearchHistory(term);
    setRecentSearches(getSearchHistory());
  }

  function removeSearch(term: string) {
    removeSearchHistory(term);
    setRecentSearches(getSearchHistory());
  }

  return { recentSearches, saveSearch, removeSearch };
};

export default useRecentSearches;
